import { EntityModel } from '@/interfaces'
import {
  ALL_GRID_BLOCK_COLUMNS_QUERY,
  CREATE_GRID_BLOCK_COLUMN_MUTATION,
  DELETE_GRID_BLOCK_COLUMN_MUTATION,
  FORCE_DELETE_GRID_BLOCK_COLUMN_MUTATION,
  SINGLE_GRID_BLOCK_COLUMN_QUERY,
  UPDATE_GRID_BLOCK_COLUMN_MUTATION,
} from './graphql'
import cmsContentBlockAssignmentEntity from '@/entities/cmsContentBlockAssignment/entity'

const cmsGridBlockColumnModel: EntityModel = {
  name: 'gridBlockColumn',
  namePlural: 'gridBlockColumns',
  uniqueName: 'cmsGridBlockColumn',
  uniqueNamePlural: 'cmsGridBlockColumns',
  path: 'cms/blocks/grid_block_column',
  baseUrl: '/cms/blocks/grid_block_columns',
  translationPrefix: 'entities:cmsGridBlockColumn.',
  getDisplayName: (values: any) => {
    return 'Grid Column'
  },
  gql: {
    getAll: ALL_GRID_BLOCK_COLUMNS_QUERY,
    getSingle: SINGLE_GRID_BLOCK_COLUMN_QUERY,
    create: CREATE_GRID_BLOCK_COLUMN_MUTATION,
    update: UPDATE_GRID_BLOCK_COLUMN_MUTATION,
    delete: DELETE_GRID_BLOCK_COLUMN_MUTATION,
    forceDelete: FORCE_DELETE_GRID_BLOCK_COLUMN_MUTATION,
  },
  attributes: {
    contentBlockAssignments: {
      name: 'contentBlockAssignments',
      label: 'entities:cmsGridBlockColumn.attributes.contentBlockAssignments.label',
      type: 'entityCollection',
      dataType: '[any]',
      getEntity: () => {
        return cmsContentBlockAssignmentEntity
      },
      defaultInput: false,
      inputType: 'text',
      validationType: 'string',
      validations: [],
    },
  },
}

export default cmsGridBlockColumnModel
